module.exports = __webpack_public_path__ + "img/avatar-4.c7ba1193.jpg";